export default __webpack_public_path__ + "static/media/header.e94aafd5.jpg";